var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.933,
    height: 20.117,
    viewBox: "0 0 22.933 20.117",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_20052",
    "data-name": "Grupo 20052",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_70",
    "data-name": "Rect\\xE1ngulo 70",
    d: "M-1.537-2H19.97a.463.463,0,0,1,.463.463V15.57a.463.463,0,0,1-.463.463H-1.537A.463.463,0,0,1-2,15.57V-1.537A.463.463,0,0,1-1.537-2Zm21.045.925H-1.075V15.107H19.507Z",
    transform: "translate(2 3.585)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_70_-_Contorno",
    "data-name": "Rect\\xE1ngulo 70 - Contorno",
    d: "M-1.537-2.25H19.97a.713.713,0,0,1,.713.713V15.57a.713.713,0,0,1-.713.713H-1.537a.713.713,0,0,1-.713-.713V-1.537A.713.713,0,0,1-1.537-2.25ZM19.97,15.782a.213.213,0,0,0,.213-.213V-1.537a.213.213,0,0,0-.213-.213H-1.537a.213.213,0,0,0-.213.213V15.57a.213.213,0,0,0,.213.213ZM-1.075-1.325H19.507a.25.25,0,0,1,.25.25V15.107a.25.25,0,0,1-.25.25H-1.075a.25.25,0,0,1-.25-.25V-1.075A.25.25,0,0,1-1.075-1.325Zm20.332.5H-.825V14.857H19.257Z",
    transform: "translate(2 3.585)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L\\xEDnea_39",
    "data-name": "L\\xEDnea 39",
    d: "M-1.537,2.095A.463.463,0,0,1-2,1.632V-1.537A.463.463,0,0,1-1.537-2a.463.463,0,0,1,.463.463V1.632A.463.463,0,0,1-1.537,2.095Z",
    transform: "translate(18.529 2)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L\\xEDnea_39_-_Contorno",
    "data-name": "L\\xEDnea 39 - Contorno",
    d: "M-1.537,2.345a.713.713,0,0,1-.713-.713V-1.537a.713.713,0,0,1,.713-.713.713.713,0,0,1,.713.713V1.632A.713.713,0,0,1-1.537,2.345Zm0-4.095a.213.213,0,0,0-.213.213V1.632a.213.213,0,0,0,.213.213.213.213,0,0,0,.213-.213V-1.537A.213.213,0,0,0-1.537-1.75Z",
    transform: "translate(18.529 2)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L\\xEDnea_40",
    "data-name": "L\\xEDnea 40",
    d: "M-1.537,2.095A.463.463,0,0,1-2,1.632V-1.537A.463.463,0,0,1-1.537-2a.463.463,0,0,1,.463.463V1.632A.463.463,0,0,1-1.537,2.095Z",
    transform: "translate(12.754 2)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L\\xEDnea_40_-_Contorno",
    "data-name": "L\\xEDnea 40 - Contorno",
    d: "M-1.537,2.345a.713.713,0,0,1-.713-.713V-1.537a.713.713,0,0,1,.713-.713.713.713,0,0,1,.713.713V1.632A.713.713,0,0,1-1.537,2.345Zm0-4.095a.213.213,0,0,0-.213.213V1.632a.213.213,0,0,0,.213.213.213.213,0,0,0,.213-.213V-1.537A.213.213,0,0,0-1.537-1.75Z",
    transform: "translate(12.754 2)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L\\xEDnea_41",
    "data-name": "L\\xEDnea 41",
    d: "M-1.537,2.095A.463.463,0,0,1-2,1.632V-1.537A.463.463,0,0,1-1.537-2a.463.463,0,0,1,.463.463V1.632A.463.463,0,0,1-1.537,2.095Z",
    transform: "translate(6.979 2)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L\\xEDnea_41_-_Contorno",
    "data-name": "L\\xEDnea 41 - Contorno",
    d: "M-1.537,2.345a.713.713,0,0,1-.713-.713V-1.537a.713.713,0,0,1,.713-.713.713.713,0,0,1,.713.713V1.632A.713.713,0,0,1-1.537,2.345Zm0-4.095a.213.213,0,0,0-.213.213V1.632a.213.213,0,0,0,.213.213.213.213,0,0,0,.213-.213V-1.537A.213.213,0,0,0-1.537-1.75Z",
    transform: "translate(6.979 2)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_72",
    "data-name": "Rect\\xE1ngulo 72",
    d: "M-1.537-2H1.378a.463.463,0,0,1,.463.463V1.378a.463.463,0,0,1-.463.463H-1.537A.463.463,0,0,1-2,1.378V-1.537A.463.463,0,0,1-1.537-2Zm2.452.925h-1.99V.915H.915Z",
    transform: "translate(5.521 8.419)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_72_-_Contorno",
    "data-name": "Rect\\xE1ngulo 72 - Contorno",
    d: "M-1.537-2.25H1.378a.713.713,0,0,1,.713.713V1.378a.713.713,0,0,1-.713.713H-1.537a.713.713,0,0,1-.713-.713V-1.537A.713.713,0,0,1-1.537-2.25ZM1.378,1.59a.213.213,0,0,0,.213-.213V-1.537a.213.213,0,0,0-.213-.213H-1.537a.213.213,0,0,0-.213.213V1.378a.213.213,0,0,0,.213.213ZM-1.075-1.325H.915a.25.25,0,0,1,.25.25V.915a.25.25,0,0,1-.25.25h-1.99a.25.25,0,0,1-.25-.25v-1.99A.25.25,0,0,1-1.075-1.325Zm1.74.5H-.825V.665H.665Z",
    transform: "translate(5.521 8.419)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_73",
    "data-name": "Rect\\xE1ngulo 73",
    d: "M-1.537-2H1.378a.463.463,0,0,1,.463.463V1.378a.463.463,0,0,1-.463.463H-1.537A.463.463,0,0,1-2,1.378V-1.537A.463.463,0,0,1-1.537-2Zm2.452.925h-1.99V.915H.915Z",
    transform: "translate(5.521 14.226)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_73_-_Contorno",
    "data-name": "Rect\\xE1ngulo 73 - Contorno",
    d: "M-1.537-2.25H1.378a.713.713,0,0,1,.713.713V1.378a.713.713,0,0,1-.713.713H-1.537a.713.713,0,0,1-.713-.713V-1.537A.713.713,0,0,1-1.537-2.25ZM1.378,1.59a.213.213,0,0,0,.213-.213V-1.537a.213.213,0,0,0-.213-.213H-1.537a.213.213,0,0,0-.213.213V1.378a.213.213,0,0,0,.213.213ZM-1.075-1.325H.915a.25.25,0,0,1,.25.25V.915a.25.25,0,0,1-.25.25h-1.99a.25.25,0,0,1-.25-.25v-1.99A.25.25,0,0,1-1.075-1.325Zm1.74.5H-.825V.665H.665Z",
    transform: "translate(5.521 14.226)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_74",
    "data-name": "Rect\\xE1ngulo 74",
    d: "M-1.537-2H1.378a.463.463,0,0,1,.463.463V1.378a.463.463,0,0,1-.463.463H-1.537A.463.463,0,0,1-2,1.378V-1.537A.463.463,0,0,1-1.537-2Zm2.452.925h-1.99V.915H.915Z",
    transform: "translate(11.296 8.419)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_74_-_Contorno",
    "data-name": "Rect\\xE1ngulo 74 - Contorno",
    d: "M-1.537-2.25H1.378a.713.713,0,0,1,.713.713V1.378a.713.713,0,0,1-.713.713H-1.537a.713.713,0,0,1-.713-.713V-1.537A.713.713,0,0,1-1.537-2.25ZM1.378,1.59a.213.213,0,0,0,.213-.213V-1.537a.213.213,0,0,0-.213-.213H-1.537a.213.213,0,0,0-.213.213V1.378a.213.213,0,0,0,.213.213ZM-1.075-1.325H.915a.25.25,0,0,1,.25.25V.915a.25.25,0,0,1-.25.25h-1.99a.25.25,0,0,1-.25-.25v-1.99A.25.25,0,0,1-1.075-1.325Zm1.74.5H-.825V.665H.665Z",
    transform: "translate(11.296 8.419)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_75",
    "data-name": "Rect\\xE1ngulo 75",
    d: "M-1.537-2H1.378a.463.463,0,0,1,.463.463V1.378a.463.463,0,0,1-.463.463H-1.537A.463.463,0,0,1-2,1.378V-1.537A.463.463,0,0,1-1.537-2Zm2.452.925h-1.99V.915H.915Z",
    transform: "translate(11.296 14.226)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_75_-_Contorno",
    "data-name": "Rect\\xE1ngulo 75 - Contorno",
    d: "M-1.537-2.25H1.378a.713.713,0,0,1,.713.713V1.378a.713.713,0,0,1-.713.713H-1.537a.713.713,0,0,1-.713-.713V-1.537A.713.713,0,0,1-1.537-2.25ZM1.378,1.59a.213.213,0,0,0,.213-.213V-1.537a.213.213,0,0,0-.213-.213H-1.537a.213.213,0,0,0-.213.213V1.378a.213.213,0,0,0,.213.213ZM-1.075-1.325H.915a.25.25,0,0,1,.25.25V.915a.25.25,0,0,1-.25.25h-1.99a.25.25,0,0,1-.25-.25v-1.99A.25.25,0,0,1-1.075-1.325Zm1.74.5H-.825V.665H.665Z",
    transform: "translate(11.296 14.226)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_76",
    "data-name": "Rect\\xE1ngulo 76",
    d: "M-1.537-2H1.378a.463.463,0,0,1,.463.463V1.378a.463.463,0,0,1-.463.463H-1.537A.463.463,0,0,1-2,1.378V-1.537A.463.463,0,0,1-1.537-2Zm2.452.925h-1.99V.915H.915Z",
    transform: "translate(17.071 8.419)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_76_-_Contorno",
    "data-name": "Rect\\xE1ngulo 76 - Contorno",
    d: "M-1.537-2.25H1.378a.713.713,0,0,1,.713.713V1.378a.713.713,0,0,1-.713.713H-1.537a.713.713,0,0,1-.713-.713V-1.537A.713.713,0,0,1-1.537-2.25ZM1.378,1.59a.213.213,0,0,0,.213-.213V-1.537a.213.213,0,0,0-.213-.213H-1.537a.213.213,0,0,0-.213.213V1.378a.213.213,0,0,0,.213.213ZM-1.075-1.325H.915a.25.25,0,0,1,.25.25V.915a.25.25,0,0,1-.25.25h-1.99a.25.25,0,0,1-.25-.25v-1.99A.25.25,0,0,1-1.075-1.325Zm1.74.5H-.825V.665H.665Z",
    transform: "translate(17.071 8.419)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_77",
    "data-name": "Rect\\xE1ngulo 77",
    d: "M-1.537-2H1.378a.463.463,0,0,1,.463.463V1.378a.463.463,0,0,1-.463.463H-1.537A.463.463,0,0,1-2,1.378V-1.537A.463.463,0,0,1-1.537-2Zm2.452.925h-1.99V.915H.915Z",
    transform: "translate(17.071 14.226)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_77_-_Contorno",
    "data-name": "Rect\\xE1ngulo 77 - Contorno",
    d: "M-1.537-2.25H1.378a.713.713,0,0,1,.713.713V1.378a.713.713,0,0,1-.713.713H-1.537a.713.713,0,0,1-.713-.713V-1.537A.713.713,0,0,1-1.537-2.25ZM1.378,1.59a.213.213,0,0,0,.213-.213V-1.537a.213.213,0,0,0-.213-.213H-1.537a.213.213,0,0,0-.213.213V1.378a.213.213,0,0,0,.213.213ZM-1.075-1.325H.915a.25.25,0,0,1,.25.25V.915a.25.25,0,0,1-.25.25h-1.99a.25.25,0,0,1-.25-.25v-1.99A.25.25,0,0,1-1.075-1.325Zm1.74.5H-.825V.665H.665Z",
    transform: "translate(17.071 14.226)",
    fill: "#777"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/icon-calendar.ecd8bfb3ba1b174b6062112486911b80.svg";
export { ForwardRef as ReactComponent };